import React from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faHistory,
  faStar,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';

import Logo from '../../assets/img/sobre-rodas.png';
import './styles.css';

const DEFAULT_BENEFITS = [
  {
    icon: faHistory,
    text: 'Todas as manutenções do seu veículo, enviadas pelas oficinas que o atenderam.',
  },
  { icon: faStar, text: 'Avalie o atendimento e ajude a oficina a cuidar ainda melhor.' },
  { icon: faShieldAlt, text: 'Seus dados protegidos, acesso só com a sua senha.' },
];

// Moldura das telas de conta do cliente: faixa da marca (painel lateral no desktop) e card do formulario.
export default function AuthLayout({
  eyebrow,
  title,
  highlight,
  benefits = DEFAULT_BENEFITS,
  className = '',
  children,
}) {
  const history = useHistory();

  return (
    <div className={`auth-page ${className}`.trim()}>
      <aside className="auth-aside">
        <button type="button" className="auth-back" onClick={() => history.push('/')}>
          <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
          Voltar para o início
        </button>
        <div className="auth-aside-content">
          <span className="auth-aside-eyebrow">{eyebrow}</span>
          <h1>
            {title} <span>{highlight}</span>
          </h1>
          <ul className="auth-benefits">
            {benefits.map(({ icon, text }) => (
              <li key={text}>
                <span className="auth-benefit-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={icon} />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <img className="auth-logo" src={Logo} alt="Sobre Rodas" />
          {children}
        </div>

        <p className="auth-copyright">© 2026 Work Inteligência</p>
      </main>
    </div>
  );
}
